module.exports = __webpack_public_path__ + "static/media/ghoda.08d5b5bf.ogg";